import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  CircularProgress,
  Chip,
  FormControlLabel,
  Radio,
  Checkbox,
  TextField,
  Switch,
} from "@mui/material";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import LoadingGif from "../../components/LoadingGif";
import { useState, useEffect } from "react";
import { ArrowLeft, X, ChevronDown, ChevronUp, ChevronRight, Plus, Minus } from "lucide-react";
import { SERVICE_OPTIONS } from "../HotelAdd_RoomInfoAdd_1";
import { useHotel } from "../../context/HotelContext";
import { useRoom } from "../../context/RoomContext";
import DashboardTab from "./DashboardTab";
import BookingListTab from "./BookingListTab";
import TenantsManagementTab from "./TenantsManagementTab";
import RoomManagementTab from "./RoomManagementTab";
import Cookies from "js-cookie";

const HotelOrderManagement = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { hotelId } = useParams();
  const isMobile = useMediaQuery("(max-width:950px)");
  const [currentTab, setCurrentTab] = useState("DashBoard");
  const [checkInModal, setCheckInModal] = useState(false);
  const [checkOutModal, setCheckOutModal] = useState(false);
  const [checkInModalTime, setCheckInModalTime] = useState(false);
  const [checkOutModalTime, setCheckOutModalTime] = useState(false);
  const [selectedVerifications, setSelectedVerifications] = useState([]);
  const [dropdownAddOpen, setDropdownAddOpen] = useState(false);
  const [dropdownRoomOpen, setDropdownRoomOpen] = useState(false);
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [checkInNotes, setCheckInNotes] = useState("");
  const [reviewModal, setReviewModal] = useState(false);
  const { fetchDraft, } = useHotel();
  const { getPetBasicInfo, updateBookingStep, fetchReviewDocument, loading, fetchRoom, updatePublishedRoomInfo } = useRoom();
  const [publishedRooms, setPublishedRooms] = useState([]);
  const [todayBookings, setTodayBookings] = useState([]);
  const [reviewBookings, setReviewBookings] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [pet, setPet] = useState([]);
  const [modalData, setModalData] = useState({});
  const [additionalServices, setAdditionalServices] = useState({});
  const [assignRooms, setAssignRooms] = useState([]);
  const [reviewResults, setReviewResults] = useState("");
  const [unConfirmReason, setUnConfirmReason] = useState("");
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const [bookingUnConfirmed, setBookingUnConfirmed] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [editReviewModal, setEditReviewModal] = useState(false);
  const [editCheckOutModal, setEditCheckOutModal] = useState(false);
  const [askInStayModal, setAskInStayModal] = useState(false);
  const [editInStayModal, setEditInStayModal] = useState(false);
  const [continueConfirm, setContinueConfirm] = useState(false);
  const [continueModal, setContinueModal] = useState(false);
  const [cancelBooking, setCancelBooking] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [cancellationOtherReason, setCancellationOtherReason] = useState("");
  const [nightStayed, setNightStayed] = useState(0);
  const [nightChanges, setNightChanges] = useState(0);
  const [revisedCheckOutDate, setRevisedCheckOutDate] = useState("");
  const [changeRooms, setChangeRooms] = useState(false);
  const [confirmEditInStayModal, setConfirmEditInStayModal] = useState(false);
  const [weekdayPrice, setWeekdayPrice] = useState(0);
  const [weekendPrice, setWeekendPrice] = useState(0);
  const [additionalAccomodationFee, setAdditionalAccomodationFee] = useState("");
  const [previousAssignedRoom, setPreviousAssignedRoom] = useState("");
  const [askConfirmModal, setAskConfirmModal] = useState(false);
  const [editConfirmModal, setEditConfirmModal] = useState(false);
  const [showFinishedModal, setShowFinishedModal] = useState(false);
  const [showCancelledModal, setShowCancelledModal] = useState(false);
  const [tenantsCheckOut, setTenantsCheckOut] = useState(false);
  const [tenantsInStay, setTenantsInStay] = useState(false);
  const [blockListConfirmed, setBlockListConfirmed] = useState(false);
  const [tabDisabled, setTabDisabled] = useState(false);
  const [openRoomMenu, setOpenRoomMenu] = useState(false);
  const [menuRoom, setMenuRoom] = useState(false);
  const [acceptBooking, setAcceptBooking] = useState(false);
  const [roomNotes, setRoomNotes] = useState("");
  const [matchedBookings, setMatchedBookings] = useState([]);

  useEffect(() => {
    const token = Cookies.get('token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  const isPdf = (file) => {
    if (!file) return false;
    if (typeof file === "string") return file.toLowerCase().endsWith(".pdf");
    return file.type === "application/pdf" || file.name?.toLowerCase().endsWith(".pdf");
  };

  const daysRemaining = (booking) => {
    const timeZone = "Asia/Taipei";
    const todayStr = new Date().toLocaleDateString("en-US", { timeZone });
    const checkOutStr = new Date(booking.checkOut.scheduledCheckOut).toLocaleDateString("en-US", { timeZone });
    const today = new Date(todayStr);
    const checkOutDate = new Date(checkOutStr);
    const timeDiff = checkOutDate - today;
    const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24));
    if (i18n.language === 'en' && daysDiff === 1) {
      return `${daysDiff} day remaining`;
    } else if (i18n.language === 'en' && daysDiff > 1) {
      return `${daysDiff} days remaining`;
    } else if (daysDiff === 0) {
      return "TodayCheckOuts";
    } else {
      return ` 還剩 ${daysDiff} 天`;
    }
  };

  const [checkInTime, setCheckInTime] = useState(() => {
    const now = new Date();
    now.setHours(now.getHours() + 8);
    return now.toISOString().slice(0, 16);
  });
  const [checkOutTime, setCheckOutTime] = useState(() => {
    const now = new Date();
    now.setHours(now.getHours() + 8);
    return now.toISOString().slice(0, 16);
  });

  const [formData, setFormData] = useState({
    addOnQuantities: {},
    pickup: 0,
    additionalFee: 0,
    total: 0,
  });

  const calculateAge = (birthDate) => {
    const birth = new Date(birthDate);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    const dayDiff = today.getDate() - birth.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  };

  const displayTime = (isoString) => {
    return new Date(isoString).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });
  };

  const displayDate = (isoString) => {
    return new Date(isoString).toISOString().split('T')[0].replace(/-/g, '/');
  };

  const displayOccupants = (room) => {
    const booking = bookings.find((booking) => booking._id === room.bookingsId);
    return booking ? booking.petName  : null;
  };

  const displaySchedule = (room) => {
    const booking = bookings.find((booking) => booking._id === room.bookingsId);
    return booking ? displayDate(booking.checkIn.scheduledCheckIn) + " - " + displayDate(booking.checkOut.scheduledCheckOut) : null;
  }

  const isRevisedCheckOutToday = revisedCheckOutDate === displayDate(new Date());

  const getPriceForDate = (date) => {
    const day = date.getDay();
    return (day === 0 || day === 6) ? weekendPrice : weekdayPrice;
  };

  const handleSaveRoomInfo = async (roomId, publishedRoomId) => {
    const payload = {
      acceptsBookings: acceptBooking,
    };

    if (roomNotes) {
      payload.notes = roomNotes;
    }

    try {
      await updatePublishedRoomInfo(roomId, publishedRoomId, payload);
      window.location.reload();
    } catch (error) {
      console.error("Failed to confirm check-in:", error);
    }
  };

  const handleDecreaseStay = () => {
    if (isRevisedCheckOutToday) return;
    const currentDate = new Date(revisedCheckOutDate.replace(/\//g, '-'));
    const nextDate = new Date(currentDate);
    nextDate.setDate(nextDate.getDate() - 1);
    const removedNightPrice = getPriceForDate(nextDate);
    setNightChanges((prev) => prev - 1);
    setNightStayed((prev) => Math.max(0, prev - 1));
    setAdditionalAccomodationFee((prev) => (Number(prev) || 0) - removedNightPrice);
    setRevisedCheckOutDate(displayDate(nextDate));
  };

  const handleIncreaseStay = () => {
    const currentDate = new Date(revisedCheckOutDate.replace(/\//g, '-'));
    const nextDate = new Date(currentDate);
    nextDate.setDate(nextDate.getDate() + 1);
    const addedNightPrice = getPriceForDate(currentDate);
    setNightChanges((prev) => prev + 1);
    setNightStayed((prev) => prev + 1);
    setAdditionalAccomodationFee((prev) => (Number(prev) || 0) + addedNightPrice);
    setRevisedCheckOutDate(displayDate(nextDate));
  };

  const calculateTotal = (addOnQuantities, additionalFee, pickup) => {
    const addOnCost = SERVICE_OPTIONS.reduce((sum, service) => {
      if (!additionalServices.selectedServices?.[service.key]) return sum;
      const quantity = Number(addOnQuantities[service.key]) || 0;
      const price = Number(additionalServices.servicePrices?.[service.key]) || 0;
      return sum + quantity * price;
    }, 0);
    return addOnCost + (Number(additionalFee) || 0) + (Number(pickup) || 0);
  };

  const getAdditionalServiceIndices = (services = {}) => {
    const indices = new Set();
    Object.keys(services).forEach((key) => {
      if (!services[key]) return;
      key.split("-").forEach((segment) => {
        if (/^\d+$/.test(segment)) {
          indices.add(Number(segment));
        }
      });
    });
    return indices;
  };

  const handleAddOnQuantityChange = (serviceKey, value) => {
    setFormData((prev) => {
      const addOnQuantities = {
        ...prev.addOnQuantities,
        [serviceKey]: value,
      };
      return {
        ...prev,
        addOnQuantities,
        total: calculateTotal(addOnQuantities, prev.additionalFee, prev.pickup),
      };
    });
  };

  const handleAdditionalFeeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      additionalFee: value,
      total: calculateTotal(prev.addOnQuantities, prev.pickup, value),
    }));
  };

  const handlePickupChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      pickup: value,
      total: calculateTotal(prev.addOnQuantities, prev.additionalFee, value),
    }));
  };

  const handleAdditionalServiceToggle = (index) => {
    setFormData((prev) => {
      const current = prev.additionalIndices || [];
      const additionalIndices = current.includes(index)
        ? current.filter((i) => i !== index)
        : [...current, index];
      return { ...prev, additionalIndices };
    });
  };

  const handleOpenModal = async (id, event) => {
    if (event === "checkIn") {
      setCheckInModal(true);
    } else if (event === "checkOut") {
      setCheckOutModal(true);
    } else if (event === "editReview") {
      setEditReviewModal(true);
      setContinueConfirm(true);
    } else if (event === "editCheckOut") {
      setEditCheckOutModal(true);
    } else if (event === "askInStay") {
      setAskInStayModal(true);
    } else if (event === "editInStay") {
      setEditInStayModal(true);
    } else if (event === "askConfirm") {
      setAskConfirmModal(true);
    } else if (event === "editConfirm") {
      setEditConfirmModal(true);
    } else if (event === "showFinished") {
      setShowFinishedModal(true);
    } else if (event === "showCancelled") {
      setShowCancelledModal(true);
    } else if (event === "tenantsCheckOut") {
      setTenantsCheckOut(true);
    } else if (event === "tenantsInStay") {
      setTenantsInStay(true);
    } else if (event === "openRoomMenu") {
      setOpenRoomMenu(true);
      const roomType = publishedRooms.data.find((room) => room._id === id) || "";
      setMenuRoom(roomType);
      setAcceptBooking(roomType.acceptsBookings);
      setRoomNotes(roomType.notes || "");
      setMatchedBookings(bookings.filter((booking) => booking.checkIn?.assignedRooms === id || booking.review?.assignedRooms === id));
      return;
    } else {
      setReviewModal(true);
    }
    setModalLoading(true);
    try {
      let booking = [];
      if (event === "checkIn" || event === "checkOut") {
        booking = todayBookings.find((b) => b._id === id);
      } else if (event === "review") {
        booking = reviewBookings.find((b) => b._id === id);
      } else {
        booking = bookings.find((b) => b._id === id);
      }
      setModalData(booking);
      if (event === "editReview" || event === "editCheckOut" || event === "askInStay" || event === "askConfirm" || event === "showCancelled") {
        setModalLoading(false);
        return;
      }
      if (event === "editInStay" || event === "editConfirm") {
        setNightChanges(0);
        setNightStayed(Math.ceil((new Date(booking.checkOut.scheduledCheckOut) - new Date(booking.checkIn.scheduledCheckIn)) / (1000 * 60 * 60 * 24)) || 0);
        setRevisedCheckOutDate(displayDate(booking.checkOut.scheduledCheckOut));
        const roomData = await fetchRoom(booking.roomId);
        setWeekdayPrice(roomData.information1.weekdayPrice || 0);
        setWeekendPrice(roomData.information1.weekendPrice || 0);
      }
      const hotelData = await fetchDraft(hotelId);
      setAdditionalServices(hotelData.additionalServices || {});
      if (booking.checkIn.addOnServices) {
        setFormData((prev) => ({
          ...prev,
          addOnQuantities: booking.checkIn.addOnServices.quantities || {},
          pickup: booking.checkIn.addOnServices.services.pickup ? booking.checkIn.addOnServices.servicePrices.pickup : 0,
          additionalFee: booking.checkIn.addOnServices.quantities.additionalFee === 1 ? booking.checkIn.addOnServices.servicePrices.additionalFee : 0,
          total: booking.checkIn.addOnServices.totalAddOnCost || 0,
          additionalIndices: [...getAdditionalServiceIndices(booking.checkIn.addOnServices.services)],
        }));
      }
      const petInfo = await getPetBasicInfo(booking.petId);
      setPet(petInfo);
      const roomsData = [];
      for (const room of publishedRooms.data) {
        if (room.roomId === booking.roomId && room.availability !== "occupied") {
          roomsData.push(room);
        }
        if ((event === "editInStay" || event === "editConfirm" || event === "showFinished") && booking.checkIn.assignedRooms ? room._id === booking.checkIn.assignedRooms : booking.review ? room._id === booking.review.assignedRooms : false) {
          setPreviousAssignedRoom(room.roomName);
        }
      }
      setAssignRooms(roomsData);
    }
    catch (error) {
      console.error("Error fetching booking or pet data:", error);
    } finally {
      setModalLoading(false);
    }
  }

  const tabs = [
    { key: "DashBoard", label: t("DashBoard") },
    { key: "BookingList", label: t("BookingList") },
    { key: "TenantsManagement", label: t("TenantsManagement") },
    { key: "RoomManagement", label: t("RoomManagement") },
  ];

  const reviewResultsLabel = [
    { id: 1, label: "ConfirmBooking", description: "CustomerWillBeNotified", },
    { id: 2, label: "UnableToConfirmBooking", description: "SelectReason", },
  ]

  const UnConfirmReviewReasonLabel = [
    { id: 1, label: "RequiredInfoDocs1", },
    { id: 2, label: "Care&Accomodation1", },
    { id: 3, label: "Care&Accomodation2", },
    { id: 4, label: "Care&Accomodation3", },
    { id: 5, label: "HotelOperations1", },
    { id: 6, label: "Other1", },
  ]

  const CancellationReason = [
    { id: 1, label: "CustomerCancellation", },
    { id: 2, label: "PetHealthConcerns", },
    { id: 3, label: "OperationalConflict", },
    { id: 4, label: "Other", },
  ]

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#F5F5F5",
  };

  const contentStyle = {
    flex: "1 0 auto",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: isMobile ? "100px 20px 60px" : "120px 80px 80px",
    maxWidth: "1600px",
    width: "100%",
  };

  const buttonStyle = {
    borderRadius: "10px",
    color: "#31BACD",
    padding: "8px 0",
    display: "flex",
    gap: 1,
    justifyContent: "center",
    border: "1px solid #E5E7EB",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#31BACD",
      color: "#fff",
    },
    "&:disabled": {
      backgroundColor: "none",
      border: "1px solid #fff",
      color: "#E5E7EB",
      cursor: "not-allowed",
    }
  };

  const closeModal = () => {
    setSelectedRoomType("");
    setAdditionalAccomodationFee(0);
    setContinueConfirm(false);
    setCancelBooking(false);
    setChangeRooms(false);
    setReviewResults("");
    if (checkInModal) {
      setCheckInModal(false);
      setFormData((prev) => ({
        ...prev,
        additionalFee: 0,
        pickup: 0,
        total: calculateTotal(prev.addOnQuantities, 0),
      }));
      setSelectedRoomType("");
    }
    else if (checkOutModal) {
      setCheckOutModal(false);
    } else if (continueModal) {
      setContinueModal(false);
    } else if (editReviewModal) {
      setEditReviewModal(false);
    } else if (editCheckOutModal) {
      setEditCheckOutModal(false);
    } else if (askInStayModal) {
      setAskInStayModal(false);
    } else if (askConfirmModal) {
      setAskConfirmModal(false);
    } else if (showFinishedModal) {
      setShowFinishedModal(false);
    } else if (editInStayModal) {
      setEditInStayModal(false);
    } else if (editConfirmModal) {
      setEditConfirmModal(false);
    } else if (confirmEditInStayModal) {
      setConfirmEditInStayModal(false);
    } else if (showCancelledModal) {
      setShowCancelledModal(false);
    } else if (tenantsCheckOut) {
      setTenantsCheckOut(false);
    } else if (tenantsInStay) {
      setTenantsInStay(false);
    } else if (openRoomMenu) {
      setOpenRoomMenu(false);
    } else {
      setReviewModal(false);
      setSelectedRoomType("");
    }
  };

  const handleReviewBooking = async () => {
    if (reviewResults === "ConfirmBooking") {
      const assignedRoom = assignRooms.find((room) => room.roomName === selectedRoomType);

      const payload = {
        assignedRooms: assignedRoom?._id || null,
      };
      try {
        await updateBookingStep(modalData._id, "confirmBooking", payload);
        if (!loading) {
          setReviewModal(false);
          setBookingConfirmed(true);
        }
      } catch (error) {
        console.error("Failed to confirm check-in:", error);
      }
    } else {
      const payload = {
        unconfirmReason: cancellationOtherReason && unConfirmReason === "Other1" ? cancellationOtherReason : unConfirmReason,
      };
      try {
        await updateBookingStep(modalData._id, "unconfirmBooking", payload);
        if (!loading) {
          setReviewModal(false);
          setBookingUnConfirmed(true);
        }
      } catch (error) {
        console.error("Failed to confirm check-in:", error);
      }
    }
  };

  const handleCancelBooking = async () => {
    const payload = {
      unconfirmReason: cancellationReason === "Other" ? cancellationOtherReason : unConfirmReason ? unConfirmReason : cancellationReason,
    };

    try {
      await updateBookingStep(modalData._id, "cancelled", payload);
      if (!loading) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Failed to confirm check-in:", error);
    }
  }

  const openReviewDocument = async (bookingId) => {
    const response = await fetchReviewDocument(bookingId);
    if (response.success) {
      setPreviewFile({
        file: { name: "Document", type: response.mimeType },
        url: response.url,
      });
    }
  };

  const openCheckInTimeModal = () => {
    setCheckInModalTime(true);
    setCheckInModal(false);
  };

  const openCheckOutTimeModal = () => {
    setCheckOutModalTime(true);
    setCheckOutModal(false);
  };

  const openContinueModal = () => {
    setReviewModal(false);
    setContinueModal(true);
  };

  const confirmButtonDisabled1 =
    (checkInModal && (!selectedRoomType || selectedVerifications.length < 4)) || (checkOutModal && (!paymentConfirmed || selectedVerifications.length < 4));

  const confirmButtonDisabled2 =
    (reviewResults === "ConfirmBooking" && selectedRoomType) || (reviewResults === "UnableToConfirmBooking" && unConfirmReason);

  const buildAddOnServicesPayload = () => {
    const services = {};
    const quantities = {};
    const servicePrices = {};

    SERVICE_OPTIONS.forEach((service) => {
      if (additionalServices.selectedServices?.[service.key]) {
        services[service.key] = true;
        quantities[service.key] = Number(formData.addOnQuantities[service.key]) || 0;
        servicePrices[service.key] = additionalServices.servicePrices[service.key];
      }
      if (formData.pickup) {
        services["pickup"] = true;
        quantities["pickup"] = 1;
        servicePrices["pickup"] = Number(formData.pickup);
      }
      if (formData.additionalFee) {
        const additionalFeeKey = formData.additionalIndices?.length > 0 ? `additionalFee-${formData.additionalIndices.join("-")}` : "additionalFee";
        services[additionalFeeKey] = true;
        quantities["additionalFee"] = 1;
        servicePrices["additionalFee"] = Number(formData.additionalFee);
      }
    });

    return { services, quantities, servicePrices };
  };

  const handleConfirmCheckIn = async () => {
    const assignedRoom = assignRooms.find((room) => room.roomName === selectedRoomType);

    const payload = {
      isCheckedIn: true,
      actualCheckInTime: new Date(checkInTime).toISOString(),
      preCheckInItems: {
        verifiedPet: selectedVerifications.includes("pet"),
        confirmedRoom: selectedVerifications.includes("room"),
        verifiedDocs: selectedVerifications.includes("docs"),
        confirmedSpecialReq: selectedVerifications.includes("care"),
      },
      addOnServices: buildAddOnServicesPayload(),
      assignedRooms: assignedRoom?._id || null,
    };

    if (checkInNotes) {
      payload.checkInNotes = checkInNotes;
    }

    try {
      await updateBookingStep(modalData._id, "checkIn", payload);
      setCheckInModalTime(false);
      window.location.reload();
    } catch (error) {
      console.error("Failed to confirm check-in:", error);
    }
  };

  const handleConfirmCheckOut = async () => {
    const payload = {
      isCheckOut: true,
      actualCheckOutTime: new Date(checkOutTime).toISOString(),
      preCheckOutItems: {
        verifiedPet: selectedVerifications.includes("pet"),
        returnedPetBelongings: selectedVerifications.includes("docs"),
        inspectedRoom: selectedVerifications.includes("room"),
        recordedSpecialNotes: selectedVerifications.includes("care"),
      },
      finalCharges: {
        accommodationFee: modalData.checkOut.finalCharges.accommodationFee,
        additionalFee: modalData.checkIn.addOnServices.totalAddOnCost,
        amountPaid: modalData.checkOut.finalCharges.amountPaid,
        amountDue: modalData.checkOut.finalCharges.amountDue,
      },
      confirmedOnSitePayment: paymentConfirmed,
    };

    try {
      await updateBookingStep(modalData._id, "checkOut", payload);
      setCheckOutModalTime(false);
      window.location.reload();
    } catch (error) {
      console.error("Failed to confirm check-out:", error);
    }
  };

  const handleUpdateInStay = async () => {
    const assignedRoom = assignRooms.find((room) => room.roomName === selectedRoomType);

    const payload = {
      addOnServices: buildAddOnServicesPayload(),
    };

    if (nightChanges !== 0) {
      payload.scheduledCheckOut = revisedCheckOutDate.replace(/\//g, '-');
      payload.additionalAccomodationFee = Number(additionalAccomodationFee) || 0;
    }


    if (changeRooms && selectedRoomType) {
      payload.assignedRooms = assignedRoom?._id || null;
      payload.checkInNotes = "Room changed from " + previousAssignedRoom + " to " + selectedRoomType + " at " + displayDate(new Date()) + displayTime(new Date()) + " ! ";
    }

    try {
      console.log("Payload for in-stay update:", payload);
      await updateBookingStep(modalData._id, "inStay", payload);
      setConfirmEditInStayModal(false);
      window.location.reload();
    } catch (error) {
      console.error("Failed to confirm in-stay update:", error);
    }
  };

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={contentStyle}>
        <Box sx={{ width: isMobile ? "100%" : "80%", mx: "auto", display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
              <Button
                onClick={() => navigate("/hotel/onboarding")}
                sx={{
                  minWidth: "auto",
                  width: isMobile ? "36px" : "44px",
                  height: isMobile ? "36px" : "44px",
                  borderRadius: "50%",
                  backgroundColor: "#31BACD",
                  color: "#fff",
                  padding: 0,
                  alignSelf: isMobile ? "flex-start" : "center",
                  "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
                }}
              >
                <ArrowLeft size={isMobile ? 18 : 22} />
              </Button>
              <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 1, alignItems: isMobile ? "flex-start" : "center", }}>
                <Typography sx={{ fontWeight: "bold", fontSize: isMobile ? "20px" : "24px", color: "#000" }}>
                  {`${t('OrderManagement')} > ${t(currentTab)}`}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* TABS */}
          <Box sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", gap: 0, width: "100%", mb: 3 }}>
              {tabs.map((tab) => (
                <Button
                  key={tab.key}
                  disabled={tabDisabled && tab.key !== "DashBoard"}
                  onClick={() => setCurrentTab(tab.key)}
                  sx={{
                    flex: 1,
                    fontSize: "18px",
                    fontWeight: currentTab === tab.key ? "700" : "500",
                    color: currentTab === tab.key ? "#31BACD" : "#666",
                    padding: "12px 0",
                    borderBottom: currentTab === tab.key ? "3px solid #31BACD" : "1px solid #D1D1D1",
                    borderRadius: 0,
                    textTransform: "none",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#31BACD",
                      backgroundColor: "rgba(49, 186, 205, 0.05)",
                    },
                  }}
                >
                  {tab.label}
                </Button>
              ))}
            </Box>

            {currentTab === "DashBoard" && (
              <DashboardTab
                publishedRooms={publishedRooms}
                setPublishedRooms={setPublishedRooms}
                todayBookings={todayBookings}
                setTodayBookings={setTodayBookings}
                reviewBookings={reviewBookings}
                setReviewBookings={setReviewBookings}
                handleOpenModal={handleOpenModal}
                setCurrentTab={setCurrentTab}
                setTabDisabled={setTabDisabled}
                displayDate={displayDate}
              />
            )}
            {currentTab === "BookingList" && <BookingListTab
              handleOpenModal={handleOpenModal}
              bookings={bookings}
              setBookings={setBookings}
              setTodayBookings={setTodayBookings}
              setReviewBookings={setReviewBookings}
              displayDate={displayDate}
            />}
            {currentTab === "TenantsManagement" && <TenantsManagementTab
              publishedRooms={publishedRooms}
              handleOpenModal={handleOpenModal}
              bookings={bookings}
              setBookings={setBookings}
              setTodayBookings={setTodayBookings}
              displayDate={displayDate}
              displayTime={displayTime}
              daysRemaining={daysRemaining}
            />}
            {currentTab === "RoomManagement" && <RoomManagementTab
              publishedRooms={publishedRooms}
              bookings={bookings}
              setBookings={setBookings}
              handleOpenModal={handleOpenModal}
              displayOccupants={displayOccupants}
              displaySchedule={displaySchedule}
            />}
          </Box>
        </Box>
      </div>

      {(checkInModal || checkOutModal || reviewModal || editReviewModal || editCheckOutModal ||
        askInStayModal || editInStayModal || askConfirmModal || editConfirmModal || showFinishedModal ||
        tenantsCheckOut || tenantsInStay || showCancelledModal) && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1300,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "10px",
                width: isMobile ? "95%" : "700px",
                padding: "20px 40px",
                maxHeight: "95vh",
                overflowY: "auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #E0E0E0",
                  paddingBottom: "8px",
                }}
              >
                <Typography sx={{ fontWeight: "700", fontSize: "20px", color: "#000" }}>
                  {checkInModal ? t("CheckIn") : checkOutModal || editCheckOutModal ? t("CheckOut") :
                    askInStayModal || editInStayModal ? t("EditinStayBooking") :
                      askConfirmModal || editConfirmModal ? t("editConfirmedBooking") :
                        showFinishedModal ? t("FinishedBooking") : showCancelledModal ? t("CancelledBooking") :
                          tenantsCheckOut || tenantsInStay ? t("TenantsManagement") : t("PendingBookings")}
                </Typography>
                <Button
                  onClick={() => closeModal()}
                  sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
                >
                  <X size={20} />
                </Button>
              </Box>

              {modalLoading ? (
                <LoadingGif />
              ) : (
                <>
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, width: "100%", justifyContent: "space-between", }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, }}>
                      <Box
                        component="img"
                        src={checkInModal ? "/icons/reviewCheckIn.svg" : reviewModal || editReviewModal ? "/icons/reviewPetImage.svg" :
                          askInStayModal || editInStayModal || tenantsCheckOut || tenantsInStay ? "/icons/reviewCheckOut.svg" :
                            showFinishedModal ? "/icons/finishedDog.svg" : askConfirmModal || editConfirmModal ? "/icons/editConfirmDog.svg" :
                              showCancelledModal ? "/icons/bookingUnConfirmed.svg" : "/icons/EditCheckOutDog.svg"}
                        alt="Pending Bookings"
                        sx={{ width: "50px", height: "auto" }}
                      />
                      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, flexDirection: "column", }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                          <Typography sx={{ fontSize: "16px", color: "#000", fontWeight: 700 }}>
                            {t("PetName")}:
                          </Typography>
                          <Typography sx={{ fontSize: "16px", color: "#666" }}>
                            {modalData.petName}
                          </Typography>
                          <Chip
                            label={checkInModal ? t("CheckIn") : reviewModal ? t("Pending") : editReviewModal ? t("pendingInfoNeeded") :
                              askConfirmModal || editConfirmModal ? t("Confirmed") : askInStayModal || editInStayModal || tenantsCheckOut || tenantsInStay ? t("inStay") :
                                showFinishedModal ? t("Finished") : showCancelledModal ? t("Cancelled") : t("CheckOut")}
                            size="large"
                            sx={{
                              backgroundColor: checkInModal ? "#FFB60D" : reviewModal ? "#31BACD" : editReviewModal || showCancelledModal ? "#FFF" :
                                askInStayModal || editInStayModal || tenantsCheckOut || tenantsInStay ? "#FF6900" : askConfirmModal || editConfirmModal ? "#00A63E" : showFinishedModal ? "#E5E7EB" : "#E5194A",

                              color: editReviewModal ? "#666" : showCancelledModal ? "#E5194A" : "#fff",
                              border: editReviewModal ? "1px solid #666" : showCancelledModal ? "1px solid #E5194A" : "none",
                              fontSize: "14px",
                              height: "20px",
                              margin: "0 auto",
                              padding: "4px 8px",
                            }}
                          />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                          <Typography sx={{ fontSize: "16px", color: "#000", }}>
                            {t("BookingNo")}
                          </Typography>
                          <Typography sx={{ fontSize: "14px", color: "#4A5565" }}>
                            #{modalData.bookingNo}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    {(tenantsCheckOut || tenantsInStay) && (
                      daysRemaining(modalData) === "TodayCheckOuts" ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, padding: "6px 0px", }}>
                          <Box
                            component="img"
                            src="/icons/todayCheckOut.svg"
                            alt="Today Check-Out"
                            sx={{ width: "24px", height: "auto" }}
                          />
                          <Typography sx={{ fontSize: "14px", color: "#E5194A", }}>
                            {t("TodayCheckOuts")}
                          </Typography>
                        </Box>
                      ) : (
                        <Typography sx={{ fontSize: "14px", backgroundColor: "#F3F4F6", color: "#4A5565", borderRadius: "20px", padding: "8px 12px", fontWeight: 700, }}>
                          {daysRemaining(modalData)}
                        </Typography>
                      )
                    )}
                  </Box>
                  {editReviewModal || askConfirmModal ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center", width: "100%", padding: "12px 0", }}>
                      {editReviewModal ? (
                        <Button
                          sx={{
                            border: "1px solid #F3F4F6",
                            borderRadius: "8px",
                            padding: "12px",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#E6F7F8", cursor: "pointer" },
                          }}
                          onClick={() => { setEditReviewModal(false); handleOpenModal(modalData._id, "review") }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                            <Box
                              component="img"
                              src="/icons/EditReview.svg"
                              alt="edit"
                              sx={{ width: "40px", height: "auto" }}
                            />
                            <Typography sx={{ fontSize: "16px", color: "#000", }}>
                              {t("ReviewBooking")}
                            </Typography>
                          </Box>
                          <ChevronRight size={20} color="#31BACD" />
                        </Button>
                      ) : (
                        <Button
                          onClick={() => { setAskConfirmModal(false); askConfirmModal ? handleOpenModal(modalData._id, "editConfirm") : handleOpenModal(modalData._id, "editInStay") }}
                          sx={{
                            border: "1px solid #F3F4F6",
                            borderRadius: "8px",
                            padding: "12px",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#E6F7F8", cursor: "pointer" },
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                            <Box
                              component="img"
                              src="/icons/EditReview.svg"
                              alt="edit"
                              sx={{ width: "40px", height: "auto" }}
                            />
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>
                              <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#000", }}>
                                {t("EditBookingDetails")}
                              </Typography>
                              <Typography sx={{ fontSize: "14px", color: "#666", }}>
                                {t("ModifyDates")}
                              </Typography>
                            </Box>
                          </Box>
                          <ChevronRight size={20} color="#31BACD" />
                        </Button>
                      )}
                      <Button
                        onClick={() => setCancelBooking(true)}
                        sx={{
                          border: "1px solid #F3F4F6",
                          borderRadius: "8px",
                          padding: "12px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          textTransform: "none",
                          "&:hover": { backgroundColor: "#FEF0ED", cursor: "pointer" },
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                          <Box
                            component="img"
                            src="/icons/CancelBooking.svg"
                            alt="edit"
                            sx={{ width: "40px", height: "auto" }}
                          />
                          <Typography sx={{ fontSize: "16px", color: "#000", }}>
                            {t("CancelBooking")}
                          </Typography>
                        </Box>
                        <ChevronRight size={20} color="#E5194A" />
                      </Button>
                      {cancelBooking && (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 2, gap: 2, }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {t("CancellationReason")}
                              <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                            {CancellationReason.map((data, idx) => (
                              <>
                                <FormControlLabel
                                  key={idx}
                                  control={
                                    <Radio
                                      checked={cancellationReason === data.label}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setCancellationReason(data.label);
                                        }
                                      }}
                                      sx={{
                                        color: "#999",
                                        "&.Mui-checked": {
                                          color: "#31BACD",
                                        },
                                      }}
                                    />
                                  }
                                  label={
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", }}>
                                      <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                        {t(data.label)}
                                      </Typography>
                                    </Box>
                                  }
                                  sx={{
                                    border: "1px solid #D1D1D1",
                                    borderRadius: "8px",
                                    padding: "8px",
                                    margin: 0,
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    "&:hover": {
                                      borderColor: "#31BACD",
                                      backgroundColor: "rgba(49, 186, 205, 0.05)",
                                    },
                                  }}
                                />
                                {data.label === "Other" && cancellationReason === "Other" && (
                                  <TextField
                                    fullWidth
                                    placeholder={t("Other1")}
                                    value={cancellationOtherReason}
                                    onChange={(e) => setCancellationOtherReason(e.target.value)}
                                    sx={{
                                      "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#FFFFFF",
                                        borderRadius: "10px",
                                      },
                                    }}
                                  />
                                )}
                              </>
                            ))}
                          </Box>
                          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", alignSelf: "flex-end", }}>
                            <Button
                              onClick={() => closeModal()}
                              sx={{
                                padding: "10px 24px",
                                backgroundColor: "#F5F5F5",
                                color: "#666",
                                textTransform: "none",
                                fontSize: "16px",
                                fontWeight: "600",
                                borderRadius: "10px",
                                "&:hover": { backgroundColor: "#EBEBEB" },
                              }}
                            >
                              {t("Cancel")}
                            </Button>
                            <Button
                              sx={{
                                padding: "10px 24px",
                                backgroundColor: "#31BACD",
                                color: "#fff",
                                textTransform: "none",
                                fontSize: "16px",
                                fontWeight: "600",
                                borderRadius: "10px",
                                "&:hover": { backgroundColor: "#2BA5B8" },
                                "&:disabled": { backgroundColor: "#F5F5F5", },
                              }}
                              disabled={(cancelBooking && !cancellationReason) || (cancelBooking && cancellationReason === "Other" && !cancellationOtherReason)}
                              onClick={() => handleCancelBooking()}
                            >
                              {loading ? <CircularProgress size={20} color="inherit" /> : t("Confirm")}
                            </Button>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  ) : editCheckOutModal || askInStayModal ? (
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center", width: "100%", padding: "12px 0", }}>
                      <Button
                        onClick={() => { editCheckOutModal ? setEditCheckOutModal(false) : setAskInStayModal(false); handleOpenModal(modalData._id, "editInStay") }}
                        sx={{
                          border: "1px solid #F3F4F6",
                          borderRadius: "8px",
                          padding: "12px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          textTransform: "none",
                          "&:hover": { backgroundColor: "#E6F7F8", cursor: "pointer" },
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                          <Box
                            component="img"
                            src="/icons/EditReview.svg"
                            alt="edit"
                            sx={{ width: "40px", height: "auto" }}
                          />
                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#000", }}>
                              {t("EditBookingDetails")}
                            </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#666", }}>
                              {t("ModifyDates")}
                            </Typography>
                          </Box>
                        </Box>
                        <ChevronRight size={20} color="#31BACD" />
                      </Button>
                      <Button
                        onClick={() => { editCheckOutModal ? setEditCheckOutModal(false) : setAskInStayModal(false); handleOpenModal(modalData._id, "checkOut") }}
                        sx={{
                          border: "1px solid #F3F4F6",
                          borderRadius: "8px",
                          padding: "12px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          textTransform: "none",
                          "&:hover": { backgroundColor: "#FEF0ED", cursor: "pointer" },
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                          <Box
                            component="img"
                            src="/icons/editCheckOut.svg"
                            alt="edit"
                            sx={{ width: "40px", height: "auto" }}
                          />
                          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#000", }}>
                              {t("CheckOutAction")}
                            </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#666", }}>
                              {t("CompletePayment")}
                            </Typography>
                          </Box>
                        </Box>
                        <ChevronRight size={20} color="#E5194A" />
                      </Button>
                    </Box>
                  ) : editInStayModal || editConfirmModal ? (
                    <>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000", }}>
                          {t("CurrentinStayDetails")}
                        </Typography>
                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
                          <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", borderRadius: "10px", p: 2, backgroundColor: "#F9FAFB", }}>
                            <Typography sx={{ fontSize: "16px", color: "#99A1AF", }}>
                              {t("ScheduledCheckIn")}
                            </Typography>
                            <Typography sx={{ fontSize: "16px", color: "#000" }}>
                              {displayDate(modalData.checkIn.scheduledCheckIn)}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", borderRadius: "10px", p: 2, backgroundColor: "#F9FAFB", }}>
                            <Typography sx={{ fontSize: "16px", color: "#99A1AF", }}>
                              {t("RoomType")}
                            </Typography>
                            <Typography sx={{ fontSize: "16px", color: "#000" }}>
                              {modalData.roomName}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", borderRadius: "10px", p: 2, backgroundColor: "#F9FAFB", }}>
                            <Typography sx={{ fontSize: "16px", color: "#99A1AF", }}>
                              {t("ScheduledCheckOut")}
                            </Typography>
                            <Typography sx={{ fontSize: "16px", color: "#000" }}>
                              {displayDate(modalData.checkOut.scheduledCheckOut)}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", borderRadius: "10px", p: 2, backgroundColor: "#F9FAFB", }}>
                            <Typography sx={{ fontSize: "16px", color: "#99A1AF", }}>
                              {t("NightsStayed")}
                            </Typography>
                            <Typography sx={{ fontSize: "16px", color: "#000" }}>
                              {Math.ceil((new Date(modalData.checkOut.scheduledCheckOut) - new Date(modalData.checkIn.scheduledCheckIn)) / (1000 * 60 * 60 * 24))}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000", }}>
                          {t("ExtendStay")}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, }}>
                          <Button onClick={handleDecreaseStay} disabled={isRevisedCheckOutToday} sx={buttonStyle}>
                            <Minus size={24} />
                          </Button>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, }}>
                            <Typography sx={{ fontSize: "30px", fontWeight: "700", color: "#000" }}>
                              {nightStayed}
                            </Typography>
                            <Typography sx={{ fontSize: "16px", color: "#99A1AF" }}>
                              {t("nights")}
                            </Typography>
                          </Box>
                          <Button onClick={handleIncreaseStay} sx={buttonStyle}>
                            <Plus size={24} />
                          </Button>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", borderRadius: "10px", p: 2, backgroundColor: "#F9FAFB", gap: 1 }}>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", }}>
                            <Typography sx={{ fontSize: "16px", color: "#99A1AF", }}>
                              {t("RevisedCheckOutDate")}
                            </Typography>
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                              {revisedCheckOutDate}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", }}>
                            <Typography sx={{ fontSize: "16px", color: "#99A1AF", }}>
                              {t("TotalStay")}
                            </Typography>
                            <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                              {nightStayed} {t("nights")}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column", width: "100%", }}>
                        <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                          <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                            {t("AddonServices")}
                          </Typography>
                          <Button
                            onClick={() => dropdownAddOpen ? setDropdownAddOpen(false) : setDropdownAddOpen(true)}
                            sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
                          >
                            {dropdownAddOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                          </Button>
                        </Box>
                        {dropdownAddOpen && (
                          <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #E0E0E0", borderRadius: "8px", }}>
                            {SERVICE_OPTIONS.map((service) => {
                              const isSelected = additionalServices.selectedServices[service.key];
                              return isSelected ? (
                                <Box key={service.key} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                                    <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                      {t(service.labelKey)}
                                    </Typography>
                                    {additionalServices.selectedServices[service.key] && (
                                      <Typography sx={{ fontWeight: "600", fontSize: isMobile ? "14px" : "16px", color: "#000" }}>
                                        {`HK$${additionalServices.servicePrices[service.key]} ${service.unitKey === "UnitPerMinute" ? `/ ${additionalServices.servicePrices.playtime} ` : ''}${t(service.unitKey)}`}
                                      </Typography>
                                    )}
                                  </Box>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    value={formData.addOnQuantities[service.key] ?? 0}
                                    onChange={(e) => handleAddOnQuantityChange(service.key, Number(e.target.value))}
                                    sx={{
                                      width: "100px",
                                      "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#FFFFFF",
                                        borderRadius: "10px",
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        padding: "10px",
                                      },
                                    }}
                                  />
                                </Box>
                              ) : null;
                            })}
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                  {t("ServicePickup")}
                                </Typography>

                              </Box>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", fontWeight: "700", color: "#000", }}>
                                  HK$
                                </Typography>
                                <TextField
                                  fullWidth
                                  type="number"
                                  value={formData.pickup ?? 0}
                                  onChange={(e) => handlePickupChange(Number(e.target.value))}
                                  sx={{
                                    width: "100px",
                                    "& .MuiOutlinedInput-root": {
                                      backgroundColor: "#FFFFFF",
                                      borderRadius: "10px",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: "10px",
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                              <Box sx={{ display: "flex", alignItems: "flex-start", flexDirection: "column", }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                    {t("AnyAdditionalServices")}
                                  </Typography>

                                </Box>
                                {additionalServices.customServices.map((row, index) => (
                                  <Box key={index} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", }}>
                                    <Checkbox
                                      size="small"
                                      checked={(formData.additionalIndices || []).includes(index)}
                                      onChange={() => handleAdditionalServiceToggle(index)}
                                      sx={{
                                        color: "#D1D1D1",
                                        "&.Mui-checked": { color: "#31BACD" },
                                      }}
                                    />
                                    <Typography sx={{ fontSize: isMobile ? "12px" : "14px", color: "#364153", }}>
                                      {t(row.label)}
                                    </Typography>
                                  </Box>
                                ))}
                              </Box>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", fontWeight: "700", color: "#000", }}>
                                  HK$
                                </Typography>
                                <TextField
                                  fullWidth
                                  type="number"
                                  value={formData.additionalFee ?? 0}
                                  onChange={(e) => handleAdditionalFeeChange(Number(e.target.value))}
                                  sx={{
                                    width: "100px",
                                    "& .MuiOutlinedInput-root": {
                                      backgroundColor: "#FFFFFF",
                                      borderRadius: "10px",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: "10px",
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", backgroundColor: "#F5F5F5", }}>
                              <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", fontWeight: "700" }}>
                                {t("TotalAdditionalServiceFee")}
                              </Typography>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", fontWeight: "700", color: "#000", }}>
                                  HK$
                                </Typography>
                                <TextField
                                  fullWidth
                                  type="number"
                                  disabled
                                  value={formData.total}
                                  sx={{
                                    width: "100px",
                                    "& .MuiOutlinedInput-root": {
                                      backgroundColor: "#FFFFFF",
                                      borderRadius: "10px",
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      padding: "10px",
                                    },
                                  }}
                                />
                              </Box>
                            </Box>
                          </Box>
                        )}
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                        {!changeRooms ? (
                          <Button sx={buttonStyle} onClick={() => { setChangeRooms(true); }}>
                            <Box
                              component="img"
                              src="/icons/changeRoomIcon.svg"
                              alt="alert"
                              sx={{ width: "20px", height: "auto" }}
                            />
                            <Typography sx={{ fontSize: "16px", color: "#4A5565", textTransform: "none", }}>
                              {t("ChangeRoom")}
                            </Typography>
                          </Button>
                        ) : (
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", borderRadius: "10px", p: 2, border: "1px solid #E5E7EB", }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000", }}>
                              {t("ChangeAbleRoom")}:
                            </Typography>
                            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
                              {assignRooms.map((arrival, idx) => (
                                <FormControlLabel
                                  key={idx}
                                  control={
                                    <Radio
                                      checked={selectedRoomType === arrival.roomName}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSelectedRoomType(arrival.roomName);
                                        }
                                      }}
                                      sx={{
                                        color: "#999",
                                        "&.Mui-checked": {
                                          color: "#31BACD",
                                        },
                                      }}
                                    />
                                  }
                                  label={
                                    <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "flex", flexDirection: "column", width: "100%", }}>
                                      {arrival.roomName}
                                      {arrival.availability === "reserved" && (
                                        <span style={{ color: "#31BACD", fontWeight: "bold", fontSize: "10px", }}>
                                          ({t("Reserved")} #{arrival.bookingNo})
                                        </span>
                                      )}
                                    </Typography>
                                  }
                                  sx={{
                                    border: "1px solid #D1D1D1",
                                    borderRadius: "8px",
                                    padding: "4px 8px",
                                    margin: 0,
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    "&:hover": {
                                      borderColor: "#31BACD",
                                      backgroundColor: "rgba(49, 186, 205, 0.05)",
                                    },
                                  }}
                                />
                              ))}
                            </Box>
                          </Box>
                        )}
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                        <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                          <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                            {t("CheckInNotes")}
                          </Typography>
                        </Box>
                        <TextField
                          fullWidth
                          placeholder={t("CheckInNotes") + t("OptionalLabel")}
                          value={checkInNotes}
                          onChange={(e) => setCheckInNotes(e.target.value)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "#FFFFFF",
                              borderRadius: "10px",
                            },
                          }}
                        />
                      </Box>
                      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", alignSelf: "flex-end", }}>
                        <Button
                          onClick={() => closeModal()}
                          sx={{
                            padding: "10px 24px",
                            backgroundColor: "#F5F5F5",
                            color: "#666",
                            textTransform: "none",
                            fontSize: "16px",
                            fontWeight: "600",
                            borderRadius: "10px",
                            "&:hover": { backgroundColor: "#EBEBEB" },
                          }}
                        >
                          {t("Cancel")}
                        </Button>
                        <Button
                          sx={{
                            padding: "10px 24px",
                            backgroundColor: "#31BACD",
                            color: "#fff",
                            textTransform: "none",
                            fontSize: "16px",
                            fontWeight: "600",
                            borderRadius: "10px",
                            "&:hover": { backgroundColor: "#2BA5B8" },
                            "&:disabled": { backgroundColor: "#F5F5F5", },
                          }}
                          onClick={() => { setEditInStayModal(false); setEditConfirmModal(false); setConfirmEditInStayModal(true); }}
                        >
                          {loading ? <CircularProgress size={20} color="inherit" /> : t("Confirm")}
                        </Button>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                          {t("BookingDetails")}
                        </Typography>
                        {(tenantsCheckOut || tenantsInStay) && (
                          <Button
                            sx={{
                              display: "flex",
                              padding: "0 8px 0 0",
                              alignItems: "center",
                              textTransform: "none",
                              borderRadius: "10px",
                              "&:hover": { backgroundColor: "#E6F7F8", cursor: "pointer", },
                            }}
                            onClick={() => { setTenantsCheckOut(false); setTenantsInStay(false); handleOpenModal(modalData._id, tenantsCheckOut ? "editCheckOut" : "askInStay") }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, }}>
                              <Box
                                component="img"
                                src="/icons/EditReview.svg"
                                alt="edit"
                                sx={{ width: "30px", height: "auto" }}
                              />
                              <Typography sx={{ fontSize: "14px", color: "#31BACD", }}>
                                {t("Edit")}
                              </Typography>
                            </Box>
                          </Button>
                        )}
                      </Box>
                      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, width: "100%", }}>
                        <Box sx={{ display: "flex", alignItems: "center", }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                            {t("Owner")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                            {modalData.name}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                            {t("Phone")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                            {modalData.phoneNumber}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                            {t("RoomType")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                            {modalData.roomName}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                            {t("ScheduledCheckIn")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                            {displayDate(modalData.checkIn.scheduledCheckIn)} {displayTime(modalData.checkIn.scheduledCheckIn)}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                            {t("Animal")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                            {pet.animal === "狗" ? t("AnimalDog") :
                              pet.animal === "貓" ? t("AnimalCat") :
                                pet.animal === "兔" ? t("AnimalRabbit") : t("SmallAnimal")}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                            {t("ScheduledCheckOut")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                            {displayDate(modalData.checkOut.scheduledCheckOut)} {displayTime(modalData.checkOut.scheduledCheckOut)}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                            {t("Age")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000", }}>
                            {pet.birthday ? calculateAge(pet.birthday) : "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", width: "100px" }}>
                            {t("Sex")}
                          </Typography>
                          <Box sx={{ display: "flex", gap: 2 }}>
                            <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                              {pet.sex === "male" ? t("Male") : t("Female")}
                            </Typography>
                            <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                              {pet.sterilized ? t("Sterilized") : t("NotSterilized")}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000", }}>
                          {t("SpecialRequirement")}
                        </Typography>
                        <Box
                          sx={{
                            backgroundColor: "#FFFDE7",
                            border: "1px solid #FBC02D",
                            borderRadius: "8px",
                            padding: "12px",
                            display: "flex",
                            gap: 1,
                          }}
                        >
                          <Typography sx={{ fontSize: "14px", color: "#F57F17" }}>
                            {modalData.checkIn.specialRequirements || "N/A"}
                          </Typography>
                        </Box>
                      </Box>

                      {(checkInModal || checkOutModal) && (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", }}>
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {checkInModal ? t("PreCheckInVerification") : t("PreCheckOutVerification")}
                              <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", border: "1px solid #6A7282", borderRadius: "10px", cursor: "pointer" }}>
                              <Checkbox
                                size="small"
                                checked={selectedVerifications.length === 4}
                                onChange={(e) => {
                                  if (selectedVerifications.length === 4) {
                                    setSelectedVerifications([]);
                                  } else {
                                    setSelectedVerifications(["pet", "room", "docs", "care"]);
                                  }
                                }}
                                sx={{
                                  color: "#999",
                                  "&.Mui-checked": {
                                    color: "#31BACD",
                                  },
                                }}
                              />
                              <Typography sx={{ cursor: "pointer", fontSize: "16px", paddingRight: "8px", color: "#6A7282" }}>
                                {t("SelectAll")}
                              </Typography>
                            </Box>
                          </Box>

                          {/* Verification Items */}
                          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>

                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedVerifications.includes("pet")}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedVerifications([...selectedVerifications, "pet"]);
                                    } else {
                                      setSelectedVerifications(selectedVerifications.filter(v => v !== "pet"));
                                    }
                                  }}
                                  sx={{
                                    color: "#999",
                                    "&.Mui-checked": {
                                      color: "#31BACD",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography sx={{ fontSize: "16px", color: "#333" }}>
                                  {checkInModal ? t("VerifyPetIdentity") : t("PetIdentityVerified")}
                                </Typography>
                              }
                            />

                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedVerifications.includes("room")}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedVerifications([...selectedVerifications, "room"]);
                                    } else {
                                      setSelectedVerifications(selectedVerifications.filter(v => v !== "room"));
                                    }
                                  }}
                                  sx={{
                                    color: "#999",
                                    "&.Mui-checked": {
                                      color: "#31BACD",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography sx={{ fontSize: "16px", color: "#333" }}>
                                  {checkInModal ? t("ConfirmRoomType") : t("RoomInspectionCompleted")}
                                </Typography>
                              }
                            />

                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedVerifications.includes("docs")}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedVerifications([...selectedVerifications, "docs"]);
                                    } else {
                                      setSelectedVerifications(selectedVerifications.filter(v => v !== "docs"));
                                    }
                                  }}
                                  sx={{
                                    color: "#999",
                                    "&.Mui-checked": {
                                      color: "#31BACD",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography sx={{ fontSize: "16px", color: "#333" }}>
                                  {checkInModal ? t("VerifyRequiredDocs") : t("PetBelongingsReturned")}
                                </Typography>
                              }
                            />

                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedVerifications.includes("care")}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedVerifications([...selectedVerifications, "care"]);
                                    } else {
                                      setSelectedVerifications(selectedVerifications.filter(v => v !== "care"));
                                    }
                                  }}
                                  sx={{
                                    color: "#999",
                                    "&.Mui-checked": {
                                      color: "#31BACD",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography sx={{ fontSize: "16px", color: "#333" }}>
                                  {checkInModal ? t("ConfirmSpecialCare") : t("SpecialNotesRecorded")}
                                </Typography>
                              }
                            />
                          </Box>
                        </Box>
                      )}

                      {(reviewModal || showFinishedModal) && (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 1, mt: 2, }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {t("RequiredDocuments")}
                              <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #E0E0E0", borderRadius: "8px", }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                              <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                                {t("VaccinationRecords")}{pet.animal === "狗" && t("DogLicense")}
                              </Typography>
                              {modalData.documentsUploaded ? (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 3, color: "#31BACD", cursor: "pointer", "&:hover": { color: "#8cbec4" }, }}
                                  onClick={() => openReviewDocument(modalData._id)}
                                >
                                  <Typography sx={{ fontSize: "16px", }}>
                                    {t("View")}
                                  </Typography>
                                  <Box
                                    component="img"
                                    src="/icons/tick.svg"
                                    alt="alert"
                                    sx={{ width: "20px", height: "auto" }}
                                  />
                                </Box>
                              ) : (
                                <Box
                                  component="img"
                                  src="/icons/redCross.svg"
                                  alt="alert"
                                  sx={{ width: "20px", height: "auto" }}
                                />
                              )}
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                              <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                                {t("Terms&Conditions")}
                              </Typography>
                              {modalData.termsAgreed ? (
                                <Box
                                  component="img"
                                  src="/icons/tick.svg"
                                  alt="alert"
                                  sx={{ width: "20px", height: "auto" }}
                                />
                              ) : (
                                <Box
                                  component="img"
                                  src="/icons/redCross.svg"
                                  alt="alert"
                                  sx={{ width: "20px", height: "auto" }}
                                />)
                              }
                            </Box>
                          </Box>
                        </Box>
                      )}

                      {(!continueConfirm && reviewModal) && (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 1, }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 2, }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {t("AddonServices")}
                            </Typography>
                            <Button
                              onClick={() => dropdownAddOpen ? setDropdownAddOpen(false) : setDropdownAddOpen(true)}
                              sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
                            >
                              {dropdownAddOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                            </Button>
                          </Box>
                          {dropdownAddOpen && (
                            <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #E0E0E0", borderRadius: "8px", }}>
                              {SERVICE_OPTIONS.map((service) => {
                                const isSelected = additionalServices.selectedServices[service.key];
                                return isSelected ? (
                                  <Box key={service.key} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                                      <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                        {t(service.labelKey)}
                                      </Typography>
                                      {additionalServices.selectedServices[service.key] && (
                                        <Typography sx={{ fontWeight: "600", fontSize: isMobile ? "14px" : "16px", color: "#000" }}>
                                          {`HK$${additionalServices.servicePrices[service.key]} ${service.unitKey === "UnitPerMinute" ? `/ ${additionalServices.servicePrices.playtime} ` : ''}${t(service.unitKey)}`}
                                        </Typography>
                                      )}
                                    </Box>
                                    <TextField
                                      fullWidth
                                      type="number"
                                      inputProps={{ min: 0 }}
                                      disabled
                                      value={formData.addOnQuantities[service.key] ?? 0}
                                      sx={{
                                        width: "100px",
                                        "& .MuiOutlinedInput-root": {
                                          backgroundColor: "#FFFFFF",
                                          borderRadius: "10px",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                          padding: "10px",
                                        },
                                      }}
                                    />
                                  </Box>
                                ) : null;
                              })}
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                  {t("ServicePickup")}
                                </Typography>
                                <Typography sx={{ fontSize: isMobile ? "12px" : "14px", color: "#31BACD", fontWeight: "700" }}>
                                  {t("ToBeSettled")}
                                </Typography>
                              </Box>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                  {t("AnyAdditionalServices")}
                                </Typography>
                                <Typography sx={{ fontSize: isMobile ? "12px" : "14px", color: "#31BACD", fontWeight: "700" }}>
                                  {t("ToBeSettled")}
                                </Typography>
                              </Box>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", backgroundColor: "#F5F5F5", }}>
                                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", fontWeight: "700" }}>
                                  {t("TotalAdditionalServiceFee")}
                                </Typography>
                                <Typography sx={{ fontSize: isMobile ? "12px" : "14px", color: "#31BACD", fontWeight: "700" }}>
                                  {t("ToBeSettled")}
                                </Typography>
                              </Box>
                            </Box>
                          )}
                          <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 2, }}>
                            <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                              <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                                {t("ReviewResults")}
                                <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                              </Typography>

                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                              {reviewResultsLabel.map((data, idx) => (
                                <FormControlLabel
                                  key={idx}
                                  control={
                                    <Radio
                                      checked={reviewResults === data.label}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setReviewResults(data.label);
                                        }
                                      }}
                                      sx={{
                                        color: "#999",
                                        padding: "0",
                                        mx: 1,
                                        "&.Mui-checked": {
                                          color: idx === 0 ? "#31BACD" : "#E5194A",
                                        },
                                      }}
                                    />
                                  }
                                  label={
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", }}>
                                      <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#000" }}>
                                        {t(data.label)}
                                      </Typography>
                                      <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                        {t(data.description)}
                                      </Typography>
                                    </Box>
                                  }
                                  sx={{
                                    border: "1px solid #D1D1D1",
                                    borderRadius: "8px",
                                    padding: "8px",
                                    margin: 0,
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "flex-start",
                                    "&:hover": {
                                      borderColor: idx === 0 ? "#31BACD" : "#E5194A",
                                      backgroundColor: idx === 0 ? "rgba(49, 186, 205, 0.05)" : "rgba(229, 25, 74, 0.05)",
                                    },
                                  }}
                                />
                              ))}
                            </Box>

                          </Box>

                          {reviewResults === "UnableToConfirmBooking" && (
                            <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 2, }}>
                              <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                                <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                                  {t("PleaseSelectReason")}
                                  <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                                </Typography>
                              </Box>
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                                {UnConfirmReviewReasonLabel.map((data, idx) => (
                                  <>
                                    {data.label === "RequiredInfoDocs1" ? (
                                      <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#4A5565" }}>
                                        {t("RequiredInfoDocs")}
                                      </Typography>
                                    ) : data.label === "Care&Accomodation1" ? (
                                      <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#4A5565", mt: 2, }}>
                                        {t("Care&Accomodation")}
                                      </Typography>
                                    ) : data.label === "HotelOperations1" ? (
                                      <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#4A5565", mt: 2, }}>
                                        {t("HotelOperations")}
                                      </Typography>
                                    ) : data.label === "Other1" ? (
                                      <Typography sx={{ fontSize: "16px", fontWeight: "700", color: "#4A5565", mt: 2, }}>
                                        {t("Other")}
                                      </Typography>
                                    ) : null}
                                    <FormControlLabel
                                      key={idx}
                                      control={
                                        <Radio
                                          checked={unConfirmReason === data.label}
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              setUnConfirmReason(data.label);
                                            }
                                          }}
                                          sx={{
                                            color: "#999",
                                            "&.Mui-checked": {
                                              color: "#31BACD",
                                            },
                                          }}
                                        />
                                      }
                                      label={
                                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", }}>
                                          <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                            {t(data.label)}
                                          </Typography>
                                        </Box>
                                      }
                                      sx={{
                                        border: "1px solid #D1D1D1",
                                        borderRadius: "8px",
                                        padding: "8px",
                                        margin: 0,
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        "&:hover": {
                                          borderColor: "#31BACD",
                                          backgroundColor: "rgba(49, 186, 205, 0.05)",
                                        },
                                      }}
                                    />
                                    {data.label === "RequiredInfoDocs1" && unConfirmReason === "RequiredInfoDocs1" && (
                                      <Box sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        backgroundColor: "#FEF3CD",
                                        border: "1px solid #F5A6234D",
                                        borderRadius: "10px",
                                        padding: "8px 16px",
                                        width: "100%",
                                      }}>
                                        <Box component="img" src="/icons/ReasonsWhatsApp.svg" alt="" sx={{ width: 25, height: "auto", }} />
                                        <Typography sx={{ fontSize: "14px", color: "#B07A0A" }}>
                                          {`${t("RequiredInfoWarning1")}${modalData.phoneNumber}${t("RequiredInfoWarning2")}`}
                                        </Typography>
                                      </Box>
                                    )}
                                    {data.label === "Care&Accomodation3" && (unConfirmReason === "Care&Accomodation1" || unConfirmReason === "Care&Accomodation2" || unConfirmReason === "Care&Accomodation3") && (
                                      <Box sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        backgroundColor: "#FEF3CD",
                                        border: "1px solid #F5A6234D",
                                        borderRadius: "10px",
                                        padding: "8px 16px",
                                        width: "100%",
                                      }}>
                                        <Box component="img" src="/icons/ReasonsWhatsApp.svg" alt="" sx={{ width: 25, height: "auto", }} />
                                        <Typography sx={{ fontSize: "14px", color: "#B07A0A" }}>
                                          {`${t("Care&AccomodationWarning1")}${modalData.phoneNumber}${t("Care&AccomodationWarning2")}`}
                                        </Typography>
                                      </Box>
                                    )}
                                    {data.label === "HotelOperations1" && unConfirmReason === "HotelOperations1" && (
                                      <Box sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        backgroundColor: "#FEF3CD",
                                        border: "1px solid #F5A6234D",
                                        borderRadius: "10px",
                                        padding: "8px 16px",
                                        width: "100%",
                                      }}>
                                        <Box component="img" src="/icons/ReasonsWhatsApp.svg" alt="" sx={{ width: 25, height: "auto", }} />
                                        <Typography sx={{ fontSize: "14px", color: "#B07A0A" }}>
                                          {`${t("Care&AccomodationWarning1")}${modalData.phoneNumber}${t("Care&AccomodationWarning2")}`}
                                        </Typography>
                                      </Box>
                                    )}
                                    {data.label === "Other1" && unConfirmReason === "Other1" && (
                                      <>
                                        <TextField
                                          fullWidth
                                          placeholder={t("Other1")}
                                          value={cancellationOtherReason}
                                          onChange={(e) => setCancellationOtherReason(e.target.value)}
                                          sx={{
                                            "& .MuiOutlinedInput-root": {
                                              backgroundColor: "#FFFFFF",
                                              borderRadius: "10px",
                                            },
                                          }}
                                        />
                                        <Box sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                          backgroundColor: "#FEF3CD",
                                          border: "1px solid #F5A6234D",
                                          borderRadius: "10px",
                                          padding: "8px 16px",
                                          width: "100%",
                                        }}>
                                          <Box component="img" src="/icons/ReasonsWhatsApp.svg" alt="" sx={{ width: 25, height: "auto", }} />
                                          <Typography sx={{ fontSize: "14px", color: "#B07A0A" }}>
                                            {`${t("Care&AccomodationWarning1")}${modalData.phoneNumber}${t("Care&AccomodationWarning2")}`}
                                          </Typography>
                                        </Box>

                                      </>
                                    )}
                                  </>
                                ))}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      )}

                      {(checkInModal || showFinishedModal || tenantsCheckOut || tenantsInStay) && (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {t("AddonServices")}
                            </Typography>
                            <Button
                              onClick={() => dropdownAddOpen ? setDropdownAddOpen(false) : setDropdownAddOpen(true)}
                              sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
                            >
                              {dropdownAddOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                            </Button>
                          </Box>
                          {dropdownAddOpen && (
                            <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #E0E0E0", borderRadius: "8px", }}>
                              {SERVICE_OPTIONS.map((service) => {
                                const isSelected = additionalServices.selectedServices[service.key];
                                return isSelected ? (
                                  <Box key={service.key} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>
                                      <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                        {t(service.labelKey)}
                                      </Typography>
                                      {additionalServices.selectedServices[service.key] && (
                                        <Typography sx={{ fontWeight: "600", fontSize: isMobile ? "14px" : "16px", color: "#000" }}>
                                          {`HK$${additionalServices.servicePrices[service.key]} ${service.unitKey === "UnitPerMinute" ? `/ ${additionalServices.servicePrices.playtime} ` : ''}${t(service.unitKey)}`}
                                        </Typography>
                                      )}
                                    </Box>
                                    <TextField
                                      fullWidth
                                      type="number"
                                      disabled={showFinishedModal || tenantsCheckOut || tenantsInStay}
                                      inputProps={{ min: 0 }}
                                      value={formData.addOnQuantities[service.key] ?? 0}
                                      onChange={(e) => handleAddOnQuantityChange(service.key, Number(e.target.value))}
                                      sx={{
                                        width: "100px",
                                        "& .MuiOutlinedInput-root": {
                                          backgroundColor: "#FFFFFF",
                                          borderRadius: "10px",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                          padding: "10px",
                                        },
                                      }}
                                    />
                                  </Box>
                                ) : null;
                              })}
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                    {t("ServicePickup")}
                                  </Typography>
                                  {modalData.checkIn.addOnServices.services.pickup && !showFinishedModal && (
                                    <Typography sx={{ fontSize: isMobile ? "12px" : "14px", color: "#31BACD", fontWeight: "700" }}>
                                      {t("Pending")}
                                    </Typography>
                                  )}
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  <Typography sx={{ fontSize: isMobile ? "14px" : "16px", fontWeight: "700", color: "#000", }}>
                                    HK$
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    disabled={showFinishedModal || tenantsCheckOut || tenantsInStay}
                                    value={formData.pickup ?? 0}
                                    onChange={(e) => handlePickupChange(Number(e.target.value))}
                                    sx={{
                                      width: "100px",
                                      "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#FFFFFF",
                                        borderRadius: "10px",
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        padding: "10px",
                                      },
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", }}>
                                <Box sx={{ display: "flex", alignItems: "flex-start", flexDirection: "column", }}>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", }}>
                                      {t("AnyAdditionalServices")}
                                    </Typography>
                                    {modalData.checkIn.addOnServices.quantities.additionalFee && !showFinishedModal && (
                                      <Typography sx={{ fontSize: isMobile ? "12px" : "14px", color: "#31BACD", fontWeight: "700" }}>
                                        {t("Pending")}
                                      </Typography>
                                    )}
                                  </Box>
                                  {(!showFinishedModal && !tenantsCheckOut && !tenantsInStay) && (
                                    additionalServices.customServices.map((row, index) => (
                                      <Box key={index} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", }}>
                                        <Checkbox
                                          size="small"
                                          checked={(formData.additionalIndices || []).includes(index)}
                                          onChange={() => handleAdditionalServiceToggle(index)}
                                          sx={{
                                            color: "#D1D1D1",
                                            "&.Mui-checked": { color: "#31BACD" },
                                          }}
                                        />
                                        <Typography sx={{ fontSize: isMobile ? "12px" : "14px", color: "#364153", }}>
                                          {t(row.label)}
                                        </Typography>
                                      </Box>
                                    ))
                                  )}
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  <Typography sx={{ fontSize: isMobile ? "14px" : "16px", fontWeight: "700", color: "#000", }}>
                                    HK$
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    disabled={showFinishedModal}
                                    value={formData.additionalFee ?? 0}
                                    onChange={(e) => handleAdditionalFeeChange(Number(e.target.value))}
                                    sx={{
                                      width: "100px",
                                      "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#FFFFFF",
                                        borderRadius: "10px",
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        padding: "10px",
                                      },
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "12px", backgroundColor: "#F5F5F5", }}>
                                <Typography sx={{ fontSize: isMobile ? "14px" : "16px", color: "#000", fontWeight: "700" }}>
                                  {t("TotalAdditionalServiceFee")}
                                </Typography>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                  <Typography sx={{ fontSize: isMobile ? "14px" : "16px", fontWeight: "700", color: "#000", }}>
                                    HK$
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    disabled={showFinishedModal}
                                    value={formData.total}
                                    sx={{
                                      width: "100px",
                                      "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#FFFFFF",
                                        borderRadius: "10px",
                                      },
                                      "& .MuiOutlinedInput-input": {
                                        padding: "10px",
                                      },
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Box>
                          )}
                          {showFinishedModal && (
                            <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start", mt: 2, gap: 1, flexDirection: "column", }}>
                              <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                                {t("RoomType")}
                              </Typography>
                              <Typography sx={{ fontSize: "16px", color: "#000" }}>
                                {previousAssignedRoom}
                              </Typography>
                              <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000", mt: 2, }}>
                                {t("BlockListManagement")}
                              </Typography>
                              <Box sx={{ display: "flex", alignItems: "center", }}>
                                <Checkbox
                                  size="medium"
                                  checked={blockListConfirmed}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setBlockListConfirmed(true);
                                    } else {
                                      setBlockListConfirmed(false);
                                    }
                                  }}
                                  sx={{
                                    color: "#31BACD",
                                    "&.Mui-checked": {
                                      color: "#31BACD",
                                    },
                                  }}
                                />
                                <Typography sx={{ fontSize: "16px", color: "#666" }}>
                                  {t("BlockListManagementDesc")}
                                </Typography>
                              </Box>
                              <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000", mt: 2, }}>
                                {t("Notes")}
                              </Typography>
                              <Typography sx={{ fontSize: "16px", color: "#666" }}>
                                {modalData.checkIn.checkInNotes || t("None")}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      )}

                      {checkOutModal && (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 1 }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {t("FinalCharges")}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #E0E0E0", borderRadius: "8px", }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                              <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                                {t("AccommodationFee")}
                              </Typography>
                              <Typography sx={{ fontSize: "16px", color: "#31BACD" }}>
                                {modalData.checkOut.finalCharges.accommodationFee}
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                              <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                                {t("AdditionalServiceFee")}
                              </Typography>
                              <Typography sx={{ fontSize: "16px", color: "#31BACD" }}>
                                {modalData.checkIn.addOnServices.totalAddOnCost}
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #E0E0E0", padding: "16px", }}>
                              <Typography sx={{ fontSize: "16px", color: "##6A7282" }}>
                                {t("AmountPaid")}
                              </Typography>
                              <Typography sx={{ fontSize: "16px", color: "#31BACD", }}>
                                {modalData.checkOut.finalCharges.amountPaid}
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "#F5F5F5", padding: "16px", }}>
                              <Typography sx={{ fontSize: "16px", color: "#000", fontWeight: "700" }}>
                                {t("TotalCharges")}
                              </Typography>
                              <Typography sx={{ fontSize: "16px", color: "#31BACD", fontWeight: "700" }}>
                                {modalData.checkOut.finalCharges.amountDue}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      )}

                      {(checkInModal || reviewResults === "ConfirmBooking") && (
                        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", mt: 2 }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2, }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {t("AssignRoom")}
                              <span style={{ color: "#E5194A", marginLeft: "4px" }}>*</span>
                            </Typography>
                            {checkInModal && (
                              <Button
                                onClick={() => dropdownRoomOpen ? setDropdownRoomOpen(false) : setDropdownRoomOpen(true)}
                                sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
                              >
                                {dropdownRoomOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                              </Button>)}
                          </Box>
                          {(dropdownRoomOpen || reviewResults === "ConfirmBooking") && (
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, }}>
                              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
                                {assignRooms.map((arrival, idx) => (
                                  <FormControlLabel
                                    key={idx}
                                    control={
                                      <Radio
                                        checked={selectedRoomType === arrival.roomName}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setSelectedRoomType(arrival.roomName);
                                          }
                                        }}
                                        sx={{
                                          color: "#999",
                                          "&.Mui-checked": {
                                            color: "#31BACD",
                                          },
                                        }}
                                      />
                                    }
                                    label={
                                      <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "flex", flexDirection: "column", width: "100%", }}>
                                        {arrival.roomName}
                                        {arrival.availability === "reserved" && (
                                          <span style={{ color: "#31BACD", fontWeight: "bold", fontSize: "10px", }}>
                                            ({t("Reserved")} #{arrival.bookingNo})
                                          </span>
                                        )}
                                      </Typography>
                                    }
                                    sx={{
                                      border: "1px solid #D1D1D1",
                                      borderRadius: "8px",
                                      padding: "4px 8px",
                                      margin: 0,
                                      width: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      "&:hover": {
                                        borderColor: "#31BACD",
                                        backgroundColor: "rgba(49, 186, 205, 0.05)",
                                      },
                                    }}
                                  />
                                ))}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      )}

                      {checkInModal && (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {t("CheckInNotes")}
                            </Typography>
                          </Box>
                          <TextField
                            fullWidth
                            placeholder={t("CheckInNotes") + t("OptionalLabel")}
                            value={checkInNotes}
                            onChange={(e) => setCheckInNotes(e.target.value)}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "#FFFFFF",
                                borderRadius: "10px",
                              },
                            }}
                          />
                        </Box>
                      )}

                      {checkOutModal && (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                            <Box
                              component="img"
                              src="/icons/alertPayment.svg"
                              alt="alert"
                              sx={{ width: "16px", height: "auto" }}
                            />
                            <Typography sx={{ fontSize: "14px", color: "#E5194A" }}>
                              {t("PleaseConfirmBeforeCheckOut")}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", alignItems: "center", background: "#e5194912", border: "1px solid #E5194A", borderRadius: "10px", cursor: "pointer", padding: "10px 0" }}>
                            <Checkbox
                              size="medium"
                              checked={paymentConfirmed}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setPaymentConfirmed(true);
                                } else {
                                  setPaymentConfirmed(false);
                                }
                              }}
                              sx={{
                                color: "#e5194992",
                                "&.Mui-checked": {
                                  color: "#E5194A",
                                },
                              }}
                            />
                            <Box sx={{ display: "flex", flexDirection: "column", }}>
                              <Typography sx={{ cursor: "pointer", fontSize: "16px", color: "#E5194A", fontWeight: "700" }}>
                                {t("ConfirmOnSitePayment")}
                              </Typography>
                              <Typography sx={{ cursor: "pointer", fontSize: "12px", color: "#6A7282" }}>
                                {t("PleaseConfirmOnSitePayment")}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      )}

                      {showCancelledModal && (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%", }}>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                            <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                              {t("CancellationReason")}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", gap: 1, alignItems: "center", }}>
                            <Typography sx={{ fontSize: "16px", color: "#000" }}>
                              {UnConfirmReviewReasonLabel.find((reason) => reason.label === modalData.review.unconfirmReason) ?
                                t(UnConfirmReviewReasonLabel.find((reason) => reason.label === modalData.review.unconfirmReason).label) :
                                CancellationReason.find((reason) => reason.label === modalData.review.unconfirmReason) ?
                                  t(CancellationReason.find((reason) => reason.label === modalData.review.unconfirmReason).label) : modalData.review.unconfirmReason}
                            </Typography>
                          </Box>
                        </Box>
                      )}

                      {!showFinishedModal && !tenantsCheckOut && !tenantsInStay && !showCancelledModal && (
                        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", alignSelf: "flex-end", }}>
                          <Button
                            onClick={() => closeModal()}
                            sx={{
                              padding: "10px 24px",
                              backgroundColor: "#F5F5F5",
                              color: "#666",
                              textTransform: "none",
                              fontSize: "16px",
                              fontWeight: "600",
                              borderRadius: "10px",
                              "&:hover": { backgroundColor: "#EBEBEB" },
                            }}
                          >
                            {t("Cancel")}
                          </Button>
                          <Button
                            sx={{
                              padding: "10px 24px",
                              backgroundColor: "#31BACD",
                              color: "#fff",
                              textTransform: "none",
                              fontSize: "16px",
                              fontWeight: "600",
                              borderRadius: "10px",
                              "&:hover": { backgroundColor: "#2BA5B8" },
                              "&:disabled": { backgroundColor: "#F5F5F5", },
                            }}
                            disabled={continueConfirm ? false : reviewModal ? !confirmButtonDisabled2 : confirmButtonDisabled1}
                            onClick={() => continueConfirm ? openContinueModal() : checkInModal ? openCheckInTimeModal() : reviewModal ? handleReviewBooking() : openCheckOutTimeModal()}
                          >
                            {loading ? <CircularProgress size={20} color="inherit" /> : t("Confirm")}
                          </Button>
                        </Box>
                      )}
                    </>
                  )}
                </>
              )}
            </Box>
          </Box>
        )}

      {(checkInModalTime || checkOutModalTime) && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 2 : 4,
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "24px",
              width: isMobile ? "80%" : "auto",
              maxWidth: "700px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <Box sx={{ width: isMobile ? "100%" : "320px", flexShrink: 0, }}>
              <Box
                component="img"
                src="/icons/ppclogo.png"
                alt="Pet Pet Club"
                sx={{ height: isMobile ? "20px" : "24px", mb: 2 }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1, }}>
                <img src={checkInModalTime ? "/icons/hotelUpdated.svg" : "/icons/hotelUpdated2.svg"} alt="hotel updated" style={{ width: "56px", height: "auto" }} />
                <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                  {checkInModalTime ? t("ConfirmCheckInTitle") : t("ConfirmCheckOutTitle")}
                </Typography>
                <Typography sx={{ fontSize: "16px", color: "#000" }}>
                  {t("PleaseReview")}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, padding: "10px", backgroundColor: "#31BACD1A", borderRadius: "8px", width: "100%", border: "1px solid #31BACD", }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("PetName")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {modalData.petName}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("Owner")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {modalData.name}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("BookingNo")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {modalData.bookingNo}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("RoomType")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {modalData.roomName}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("StayPeriod")}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {displayTime(modalData.checkIn.scheduledCheckIn)} – {displayTime(modalData.checkOut.scheduledCheckOut)}
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={{ fontSize: "16px", color: "#4A5565", display: "flex", alignSelf: "flex-start", }}>
                  {checkInModalTime ? t("ActualCheckInTime") : t("ActualCheckOutTime")}
                </Typography>

                <TextField
                  type="datetime-local"
                  value={checkInModalTime ? checkInTime : checkOutTime}
                  onChange={(e) => checkInModalTime ? setCheckInTime(e.target.value) : setCheckOutTime(e.target.value)}
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "12px",
                      fontSize: "16px",
                    },
                  }}
                />

                <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                  <Button
                    onClick={() => checkInModalTime ? setCheckInModalTime(false) : setCheckOutModalTime(false)}
                    sx={{
                      padding: "8px 12px",
                      backgroundColor: "#F5F5F5",
                      color: "#666",
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "10px",
                      "&:hover": { backgroundColor: "#EBEBEB" },
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                  <Button
                    sx={{
                      padding: "8px 12px",
                      backgroundColor: "#31BACD",
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "10px",
                      "&:hover": { backgroundColor: "#2BA5B8" },
                    }}
                    onClick={() => checkInModalTime ? handleConfirmCheckIn() : handleConfirmCheckOut()}
                  >
                    {loading ? <CircularProgress size={20} color="inherit" /> : t("Confirm")}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {(confirmEditInStayModal) && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "10px",
              width: isMobile ? "95%" : "600px",
              padding: "20px 40px",
              maxHeight: "95vh",
              overflowY: "auto",
            }}
          >
            <Box sx={{ width: "100%", flexShrink: 0, }}>
              <Box
                component="img"
                src="/icons/ppclogo.png"
                alt="Pet Pet Club"
                sx={{ height: isMobile ? "20px" : "24px", mb: 2 }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, }}>
                <img src={"/icons/hotelUpdated.svg"} alt="hotel updated" style={{ width: "56px", height: "auto" }} />
                <Typography sx={{ fontSize: "20px", fontWeight: "700", color: "#000" }}>
                  {t("ConfirmChanges")}
                </Typography>
                <Typography sx={{ fontSize: "16px", color: "#000", }}>
                  {t("BookingNo")} #{modalData.bookingNo}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, padding: "10px", backgroundColor: "#31BACD1A", borderRadius: "8px", width: "100%", border: "1px solid #31BACD", }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "20px", color: "#000", fontWeight: "700" }}>
                      <span style={{ color: "#31BACD" }}>&bull;&nbsp;</span> {t("ExtendStay")}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("ExtendedDates")}:
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {nightChanges > 0 && <span style={{ color: "#000" }}>+{nightChanges} {t("nights")}</span>}
                      {nightChanges < 0 && <span style={{ color: "#000" }}>-{Math.abs(nightChanges)} {t("nights")}</span>}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("ScheduledCheckOut")}:
                    </Typography>
                    <Typography sx={{ fontSize: "16px", }}>
                      {nightChanges !== 0 && <span style={{ color: "#99A1AF", textDecoration: "line-through" }}>{displayDate(modalData.checkOut.scheduledCheckOut)}</span>}
                      {nightChanges !== 0 && <span style={{ color: "#000" }}> → </span>}
                      <span style={{ color: "#000" }}>{revisedCheckOutDate}</span>
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("AccommodationFee")}:
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#31BACD" }}>
                      {additionalAccomodationFee > 0 && `+HK$${additionalAccomodationFee}`}
                      {additionalAccomodationFee < 0 && `-HK$${Math.abs(additionalAccomodationFee)}`}
                      {additionalAccomodationFee === 0 && "+$HK0"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, padding: "10px", backgroundColor: "#31BACD1A", borderRadius: "8px", width: "100%", border: "1px solid #31BACD", }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "20px", color: "#000", fontWeight: "700" }}>
                      <span style={{ color: "#31BACD" }}>&bull;&nbsp;</span> {t("RoomChangeRecorded")}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("UpdatedAt")}:
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {displayDate(new Date())} {displayTime(new Date())}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {previousAssignedRoom}
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      →
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#000" }}>
                      {selectedRoomType || t("None")}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("RoomChangeFee")}:
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#31BACD" }}>
                      {"+$HK0"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, padding: "10px", backgroundColor: "#31BACD1A", borderRadius: "8px", width: "100%", border: "1px solid #31BACD", }}>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "20px", color: "#000", fontWeight: "700" }}>
                      <span style={{ color: "#31BACD" }}>&bull;&nbsp;</span> {t("TotalAdditionalServiceFee")}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("UpdatedTotal")}:
                    </Typography>
                    <Typography sx={{ fontSize: "16px", }}>
                      {modalData.checkIn.addOnServices.totalAddOnCost !== formData.total && <span style={{ color: "#99A1AF", textDecoration: "line-through" }}>{"HK$" + modalData.checkIn.addOnServices.totalAddOnCost}</span>}
                      {modalData.checkIn.addOnServices.totalAddOnCost !== formData.total && <span style={{ color: "#000" }}> → </span>}
                      <span style={{ color: "#000" }}>{"HK$" + formData.total}</span>
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%", }}>
                    <Typography sx={{ fontSize: "16px", color: "#6A7282" }}>
                      {t("AdditionalServiceFee")}:
                    </Typography>
                    <Typography sx={{ fontSize: "16px", color: "#31BACD" }}>
                      {"+$HK" + (formData.total - modalData.checkIn.addOnServices.totalAddOnCost)}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", }}>
                  <Typography sx={{ fontSize: "20px", color: "#6A7282", fontWeight: "700" }}>
                    {t("TotalAdditionalCharges")}:
                  </Typography>
                  <Typography sx={{ fontSize: "20px", color: "#31BACD", fontWeight: "700" }}>
                    {((formData.total - modalData.checkIn.addOnServices.totalAddOnCost) + additionalAccomodationFee) > 0 && "+$HK" + ((formData.total - modalData.checkIn.addOnServices.totalAddOnCost) + additionalAccomodationFee)}
                    {((formData.total - modalData.checkIn.addOnServices.totalAddOnCost) + additionalAccomodationFee) < 0 && "-$HK" + Math.abs((formData.total - modalData.checkIn.addOnServices.totalAddOnCost) + additionalAccomodationFee)}
                    {((formData.total - modalData.checkIn.addOnServices.totalAddOnCost) + additionalAccomodationFee) === 0 && "$HK0"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                  <Button
                    onClick={() => closeModal()}
                    sx={{
                      padding: "8px 12px",
                      backgroundColor: "#F5F5F5",
                      color: "#666",
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "10px",
                      "&:hover": { backgroundColor: "#EBEBEB" },
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                  <Button
                    sx={{
                      padding: "8px 12px",
                      backgroundColor: "#31BACD",
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "10px",
                      "&:hover": { backgroundColor: "#2BA5B8" },
                    }}
                    onClick={() => handleUpdateInStay()}
                  >
                    {loading ? <CircularProgress size={20} color="inherit" /> : t("Confirm")}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {continueModal && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "24px",
              width: isMobile ? "80%" : "auto",
              maxWidth: "700px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <Box sx={{ width: isMobile ? "100%" : "320px", flexShrink: 0, }}>
              <Box
                component="img"
                src="/icons/ppclogo.png"
                alt="Pet Pet Club"
                sx={{ height: isMobile ? "20px" : "24px", mb: 2 }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, }}>
                <Typography sx={{ fontWeight: "700", fontSize: "20px", color: "#000", }}>
                  {t("DocumentNotUpdated")}
                </Typography>
                <Typography sx={{ fontSize: "16px", color: "#000", }}>
                  {t("DoYouWishToContinue")}
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                  <Button
                    onClick={() => { setContinueModal(false); setContinueConfirm(false); }}
                    sx={{
                      padding: "8px 12px",
                      backgroundColor: "#F5F5F5",
                      color: "#666",
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "10px",
                      "&:hover": { backgroundColor: "#EBEBEB" },
                    }}
                  >
                    {t("No")}
                  </Button>
                  <Button
                    sx={{
                      padding: "8px 12px",
                      backgroundColor: "#31BACD",
                      color: "#fff",
                      textTransform: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "10px",
                      "&:hover": { backgroundColor: "#2BA5B8" },
                    }}
                    onClick={() => { setContinueModal(false); setContinueConfirm(false); handleOpenModal(modalData._id, "review") }}
                  >
                    {t("Yes")}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {(bookingConfirmed || bookingUnConfirmed) && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 2 : 4,
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: "24px",
              width: isMobile ? "80%" : "auto",
              maxWidth: "700px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <Box sx={{ width: isMobile ? "100%" : "350px", flexShrink: 0, }}>
              <Box
                component="img"
                src="/icons/ppclogo.png"
                alt="Pet Pet Club"
                sx={{ height: isMobile ? "20px" : "24px", mb: 2 }}
              />
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, }}>
                <img src={bookingConfirmed ? "/icons/hotelUpdated.svg" : "/icons/bookingUnConfirmed.svg"} alt="lock" style={{ width: "56px", height: "auto" }} />
                <Typography sx={{ fontSize: "16px", color: "#000", fontWeight: "700" }}>
                  {bookingConfirmed ? t('BookingConfirmed') : unConfirmReason === "RequiredInfoDocs1" ? t('CustomerNotified') : t('CancelBooking')}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#000", alignSelf: "center", display: "flex", textAlign: "center", }}>
                  {bookingConfirmed ? t('BookingConfirmed1') : unConfirmReason === "RequiredInfoDocs1" ? t('CustomerNotified1') : t('CustomerNotified1') + t('CancelBooking1')}
                </Typography>
                <Typography sx={{ fontSize: "14px", color: "#000", alignSelf: "center", display: "flex", textAlign: "center", }}>
                  {bookingConfirmed ? t('BookingConfirmed2') : null}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, }}>
                  {unConfirmReason !== "RequiredInfoDocs1" && bookingUnConfirmed && (
                    <Button
                      onClick={() => closeModal()}
                      sx={{
                        padding: "8px 16px",
                        backgroundColor: "#F5F5F5",
                        color: "#666",
                        textTransform: "none",
                        fontSize: isMobile ? "13px" : "14px",
                        borderRadius: "10px",
                        "&:hover": { backgroundColor: "#EBEBEB" },
                      }}
                    >
                      {t("Cancel")}
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => unConfirmReason !== "RequiredInfoDocs1" && bookingUnConfirmed ? handleCancelBooking() : window.location.reload()}
                    sx={{
                      backgroundColor: "#31BACD",
                      color: "#fff",
                      borderRadius: "10px",
                      textTransform: "none",
                      fontSize: isMobile ? "13px" : "14px",
                      padding: "8px 16px",
                      "&:hover": { backgroundColor: "#60bac6", },
                    }}
                  >
                    {t('Confirm')}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {previewFile && (
        <Box
          onClick={() => setPreviewFile(null)}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: isMobile ? "20px" : "40px",
          }}
        >
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              width: "100%",
              maxWidth: "800px",
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <Typography sx={{ fontWeight: "600", fontSize: "14px", color: "#000" }}>
                {t("VaccinationRecords")}{pet.animal === "狗" && t("DogLicense")}
              </Typography>
              <Button
                onClick={() => setPreviewFile(null)}
                sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
              >
                <X size={20} />
              </Button>
            </Box>
            <Box sx={{ flex: 1, overflow: "auto", backgroundColor: "#F5F5F5" }}>
              {isPdf(previewFile.file) ? (
                <Box
                  component="iframe"
                  src={previewFile.url}
                  onError={() => console.error("Failed to load PDF:", previewFile.url)}
                  sx={{ width: "100%", height: isMobile ? "70vh" : "80vh", border: "none" }}
                />
              ) : (
                <Box
                  component="img"
                  src={previewFile.url}
                  alt="document"
                  onError={() => console.error("Failed to load image:", previewFile.url)}
                  sx={{ width: "100%", height: "auto", display: "block" }}
                />
              )}
            </Box>
          </Box>
        </Box>
      )}

      {openRoomMenu && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: 'blur(1px)',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 2,
              backgroundColor: "#fff",
              width: isMobile ? "95%" : "500px",
              padding: "20px",
              height: "100%",
              position: "fixed",
              top: 0,
              right: 0,
              overflowY: "auto",
              zIndex: 1100,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
                borderBottom: "1px solid #E0E0E0",
                paddingBottom: "8px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontWeight: "700", fontSize: "20px", color: "#000" }}>
                  {menuRoom.roomName}
                </Typography>
                <Box
                  sx={{
                    borderRadius: "10px",
                    padding: "8px",
                    fontSize: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    minWidth: "70px",
                    backgroundColor: menuRoom.availability === "available" ? "#00A63E" : menuRoom.availability === "reserved" ? "#FFB60D" : "#FF6900",
                    color: "#fff",
                  }}
                >
                  <Box
                    component="img"
                    src={menuRoom.availability === "available" ? "/icons/roomAvailable.svg" : menuRoom.availability === "reserved" ? "/icons/roomReserved.svg" : "/icons/roomOccupied.svg"}
                    alt="roompics"
                    sx={{ width: "15px", height: "auto" }}
                  />
                  <div>{menuRoom.availability === "available" ? t('Available') : menuRoom.availability === "reserved" ? t('Reserved') : t('Occupied')}</div>
                </Box>
              </Box>
              <Button
                onClick={() => closeModal()}
                sx={{ minWidth: "auto", padding: "6px", color: "#666" }}
              >
                <X size={20} />
              </Button>
            </Box>

            <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center", }}>
              <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2, alignItems: "flex-start", justifyContent: "center", }}>
                <Typography sx={{ fontWeight: "700", fontSize: "16px", color: "#000" }}>
                  {t("AvailabilitySettings")}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1, width: "100%", backgroundColor: acceptBooking ? "#E6F7F8" : "#F9FAFB", padding: "10px", borderRadius: "10px", border: acceptBooking ? "1px solid #9DD9DD" : "1px solid #E5E7EB", }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                    <Box
                      component="img"
                      src={acceptBooking ? "/icons/availabilitySettingsIcon.svg" : "/icons/unAvailabilitySettingsIcon.svg"}
                      alt="roompics"
                      sx={{ width: "40px", height: "auto" }}
                    />
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.5, }}>
                      <Typography sx={{ fontWeight: "700", fontSize: "16px", color: acceptBooking ? "#1A7A80" : "#364153"}}>
                        {acceptBooking ? t("OpenForBookings") : t("ClosedforBookings")}
                      </Typography>
                      <Typography sx={{ fontWeight: "400", fontSize: "14px", color: acceptBooking ? "#2AABB3" : "#99A1AF"}}>
                        {acceptBooking ? t("CurrenltyAvailable") : t("CurrentlyUnavailable")}
                      </Typography>
                    </Box>
                  </Box>
                  <Switch
                    checked={acceptBooking}
                    onChange={(e) => setAcceptBooking(e.target.checked)}
                    sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#31BACD', }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#31BACD', }, }}
                  />
                </Box>
                <Typography sx={{ fontWeight: "700", fontSize: "16px", color: "#000" }}>
                  {t("ReservationArrangement")}
                </Typography>
                {matchedBookings.length > 0 ? (
                  matchedBookings.map((booking, index) => (
                    <Box key={index} sx={{ display: "flex", alignItems: "center", flexDirection: "column", gap: 1, width: "100%", padding: "10px", borderRadius: "10px", border: booking.checkIn.isCheckedIn ? "1px solid #FF6900" : "1px solid #FFB60D", }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%", }}>
                          <Typography sx={{ fontSize: "16px", fontWeight: "700", color: booking.checkIn.isCheckedIn ? "#FF6900" : "#FFB60D", }}>
                            {t("Occupants")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", color: booking.checkIn.isCheckedIn ? "#FF6900" : "#FFB60D", }}>
                            {displayOccupants(menuRoom)}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            borderRadius: "10px",
                            padding: "8px",
                            fontSize: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 1,
                            minWidth: "70px",
                            backgroundColor: booking.checkIn.isCheckedIn ? "#FF6900" : "#FFB60D",
                            color: "#fff",
                          }}
                        >
                          <Box
                            component="img"
                            src={booking.checkIn.isCheckedIn ? "/icons/roomOccupied.svg" : "/icons/roomReserved.svg"}
                            alt="roompics"
                            sx={{ width: "15px", height: "auto" }}
                          />
                          <div>{booking.checkIn.isCheckedIn ? t('Occupied') : t('Reserved')}</div>
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%", mb: 1 }}>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", }}>
                            {t("StayPeriod")}
                          </Typography>
                          <Typography sx={{ fontSize: "16px", color: "#4A5565", }}>
                            {displaySchedule(menuRoom)}
                          </Typography>
                        </Box>
                        <Typography sx={{ fontSize: "16px", color: "#31BACD", textDecoration: "underline", cursor: "pointer", minWidth: "40px", }} onClick={() => handleOpenModal(booking._id, booking.checkIn.isCheckedIn ? "askInStay" : "askConfirm")}>
                          {t("View")}
                        </Typography>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, width: "100%", padding: "20px 10px", borderRadius: "10px", backgroundColor: "#F9FAFB", }}>
                    <img src="/icons/noRooms.svg" alt="paw" style={{ width: "20px", height: "auto" }} />
                    <Box sx={{ fontSize: "16px", color: "#D9D9D9", fontWeight: 700, }}>
                      {t('NoUpcomingReservations')}
                    </Box>
                  </Box>
                )}
                <Typography sx={{ fontWeight: "700", fontSize: "16px", color: "#000" }}>
                  {t("RoomNotes")}
                </Typography>
                <TextField
                  multiline
                  rows={2}
                  placeholder={t("AddNotes")}
                  value={roomNotes}
                  onChange={(e) => setRoomNotes(e.target.value)}
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "5px",
                      fontSize: "14px",
                    },
                  }}
                />
              </Box>
              <Button sx={{ padding: "10px", display: "flex", width: "100%", alignItems: "center", backgroundColor: "#31BACD", color: "#fff", textTransform: "none", fontSize: "16px", fontWeight: "700", borderRadius: "10px", "&:hover": { backgroundColor: "#2BA5B8" }, }}
                onClick={() => handleSaveRoomInfo(menuRoom.roomId, menuRoom._id)}
              >
                {loading ? <CircularProgress size={20} color="inherit" /> : t("Confirm")}
              </Button>
            </Box>
          </Box>
        </Box>
      )}
      <Footer />
    </div>
  );
};

export default HotelOrderManagement;
